import { render, staticRenderFns } from "./OrderGeneralDisplay.vue?vue&type=template&id=02c327d0&scoped=true&"
import script from "./OrderGeneralDisplay.vue?vue&type=script&lang=js&"
export * from "./OrderGeneralDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c327d0",
  null
  
)

export default component.exports